import React from 'react';
import RichTextBranch from "./RichTextBranch";
import RichTextLeaf from './RichTextLeaf';
import * as defaultRenderStyles from './DefaultRenderStyles';

export default function RichTextRenderer(props) {
	const { node, renderStyles, parentNodeType, marks, ...restProps } = props;

	if (!node)
		return null;

	// If we are a branch node
	if ((node.hasOwnProperty("content") && node.content.length) || node.nodeType === 'hr') {
		return (
			<RichTextBranch component={node.nodeType} data={node.data} renderStyles={renderStyles ? renderStyles : defaultRenderStyles} parentNodeType={parentNodeType} element={restProps.element}>
				{ node.content.map((innerNode, index) => {

					// Check surrounding marks to also apply to merge tags
					let marks = [];
					if (innerNode.nodeType === 'embedded-entry-inline' && innerNode.data.target.sys && innerNode.data.target.sys.contentType.sys.id === 'mergeTag') {
						let previousMarks = index > 0 ? node.content[index - 1].marks : [];
						let nextMarks = index < node.content.length - 1 ? node.content[index + 1].marks : [];
						if (index === 0) {
							marks = nextMarks;
						}
						else if (index === node.content.length) {
							marks = previousMarks;
						}
						else {
							marks = previousMarks ? previousMarks.filter(pm => nextMarks ? nextMarks.find(nm => nm.type === pm.type) : null) : null;
						}
					}

					return (
						<RichTextRenderer
							{...restProps}
			                key={index}
							node={innerNode}
							parentNodeType={node.nodeType}
							renderStyles={renderStyles}
							marks={marks && marks.length ? marks : undefined}
						/>
					);
				})}
			</RichTextBranch>
		);
	}

	// If we are a leaf node
	else if (node.hasOwnProperty("value") || (node.hasOwnProperty('nodeType') && ['embedded-entry-inline', 'embedded-asset-block'].includes(node.nodeType))) {
		return (
			<RichTextLeaf
				nodeType={node.nodeType}
				value={node.value}
				marks={marks ? marks : node.marks}
				data={node.data}
				embeddedEntryResolver={props.embeddedEntryResolver}
			/>
		);
	}

	// TODO - Log this error somewhere
	// TODO - Fail gracefully if possible
	return null;
}
